module.exports = __webpack_public_path__ + "img/ico_device_mobile_on.3e7e68b9.svg";